<template>
  <div class="pc-list" ref="list" v-if="list.id">
    <h1 style="display: inline-block">{{ title }}</h1>
    <span v-if="title">的文章</span>
    <div class="pc-head">
      <div class="pc-head-handle">
        <div class="pc-head-btn">
          <button @click="deleteEntryInit">删除</button>
          <span></span>
          <button @click="addArticle">添加</button>
        </div>
        <p>{{ "共" + pagination_options.total + "条" }}</p>
      </div>
    </div>

    <el-table class="pc-list-table" :data="articleList">
      <el-table-column width="100" class="singleCheckStyle" fixed="left">
        <template slot="header" slot-scope="header">
          <el-checkbox v-model="isSelectAll" @change="selectAll">{{
            "已选" + checked.length + "个"
          }}</el-checkbox>
        </template>
        <template slot-scope="scope" fixed="left">
          <el-checkbox
            v-model="articleList[scope.$index].isSelect"
            @change="
              singleCheck(
                scope.$index,
                scope.row.isSelect,
                scope.row.id,
                scope.row
              )
            "
          ></el-checkbox>
        </template>
      </el-table-column>
      <el-table-column fixed="left" prop="id" label="ID" width="80">
        <template slot-scope="scope">
          <div>
            {{ scope.row.id }}
          </div>
        </template>
      </el-table-column>
      <el-table-column prop="cover_image" label="图片" width="110" fixed="left">
        <template slot-scope="scope">
          <div class="eltable-img">
            <img v-if="scope.row.cover_image" :src="scope.row.cover_image" />
          </div>
        </template>
      </el-table-column>
      <el-table-column fixed="left" prop="title" label="标题" width="180">
        <template slot-scope="scope">
          <div>
            {{ scope.row.title }}
          </div>
        </template>
      </el-table-column>

      <el-table-column prop="author" label="作者" width="170">
        <template slot-scope="scope">
          <div v-if="scope.row.author">
            {{ scope.row.author | scholarname }}
          </div>
        </template>
      </el-table-column>
      <el-table-column prop="link" label="链接" width="170">
        <template slot-scope="scope">
          <div v-if="scope.row.link">
            {{ scope.row.link }}
          </div>
        </template>
      </el-table-column>
      <el-table-column prop="thumb_nums" label="点赞" width="170">
        <template slot-scope="scope">
          <div v-if="scope.row.thumb_nums">
            {{ scope.row.thumb_nums }}
          </div>
        </template>
      </el-table-column>
            <el-table-column prop="classification_order" label="排序" width="170">
        <template slot-scope="scope">
          <div v-if="scope.row.classification_order">
            {{ scope.row.classification_order}}
          </div>
        </template>
      </el-table-column>
      <el-table-column label="状态" prop="status" width="100">
        <template slot-scope="scope">
          <el-switch
            v-model="scope.row.status"
            active-color="#91CC75"
            inactive-color="#C7C7C7"
            @change="changeState(scope.row)"
            :active-value="1"
            :inactive-value="0"
          >
          </el-switch>
        </template>
      </el-table-column>
      <!-- <el-table-column label="创建时间" prop="create_time" width="100">
        <template slot-scope="scope">
          <div>{{ $dtime(scope.row.create_time).format("YYYY-MM-DD") }}</div>
        </template>
      </el-table-column> -->
      <el-table-column label="更新时间" prop="update_time" width="100">
        <template slot-scope="scope">
          <div>{{ $dtime(scope.row.update_time).format("YYYY-MM-DD") }}</div>
        </template>
      </el-table-column>
      <el-table-column width="120">
        <template slot-scope="scope">
          <button class="btnViewDetail" @click="viewDetail(scope.row)">
            查看详情
          </button>
        </template>
      </el-table-column>
      <!-- <el-table-column width="120">
        <template slot-scope="scope">
          <button class="btnViewDetail" @click="preview(scope.row)">
            预览
          </button>
        </template>
      </el-table-column> -->
    </el-table>
    <!-- <el-dialog
      class="articleDialog"
      :title="ArticleDetail.title"
      :visible.sync="isUpdateShow"
      width="30%"
    >
      <el-form label-width="80px">
        <el-form-item label="主题">
          <p>{{ list.title }}</p>
        </el-form-item>
        <el-form-item label="图片">
          <UploadImage
            :img="ArticleDetail.cover_image"
            :width="220"
            :height="180"
            @getUploadImage="getUploadImage"
          ></UploadImage>
        </el-form-item>
        <el-form-item label="标题">
          <el-input v-model="ArticleDetail.title"></el-input>
        </el-form-item>
        <el-form-item label="作者">
          <keywordsinput
            :maxLen="18"
            :key="1"
            v-model="ArticleDetail.author"
          ></keywordsinput>
        </el-form-item>
        <el-form-item label="简介">
          <el-input
            type="textarea"
            :rows="2"
            v-model="ArticleDetail.description"
          ></el-input>
        </el-form-item>
        <el-form-item label="文件">
          <UploadFile
            :file="ArticleDetail.origin_pdf"
            @getUploadFile="getUploadSource"
            :title="'文件'"
          ></UploadFile>
        </el-form-item>
        <el-switch
          v-model="ArticleDetail.status"
          active-color="#91CC75"
          inactive-color="#C7C7C7"
          :active-value="1"
          :inactive-value="0"
          style="margin-left: 40px"
        >
        </el-switch>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button
          class="dialog-footer-button-one"
          @click="isUpdateShow = false"
          >取 消</el-button
        >
        <el-button
          class="dialog-footer-button-second"
          type="primary"
          @click="submitBanner(list)"
          >确 定</el-button
        >
      </span>
    </el-dialog> -->
    <DeleteHint
      :dialogVisible="deleteDialogVisible"
      @cancel="closeDelete"
      @delete="isDelete"
    />
    <Pagination
      v-if="articleList.length > 0"
      :pagination="pagination_options"
      @goPage="goPage"
    />
  </div>
</template>

<script>
import UploadImage from "../../../componentSet/uploadImage.vue";
import UploadFile from "../../../componentSet/uploadFile.vue";
import Pagination from "@/components/componentSet/Pagination";
import DeleteHint from "@/components/template/DeleteHint";
import {
  magazineArticleList_Api,
  getArticleDetail_Api,
  updateArticleDetail_Api,
  setArticleDetail_Api,
  deleteMagazineArticleList_Api,
} from "@/apis/magazine.api";
export default {
  components: {
    Pagination,
    DeleteHint,
    UploadImage,
    UploadFile,
  },
  data() {
    return {
      loading: false,
      deleteDialogVisible: false,
      isUpdateShow: false,
      isActive: null,
      searchRules: {
        page: 1,
        page_size: 10,
        order: "-id",
        id: null,
      },
      pagination_options: {
        page: 1,
        total: 0,
        take: 10,
      },
      ArticleDetail: {
        author: "",
        magazine_topic: null,
        magazine_article_id: null,
      },
      isSelectAll: false,
      magazine_topic_id: null,
      articleList: [],
      checked: [],
      list: {},
      title: "",
      classification_id:null
    };
  },
  filters: {
    scholarname: function (value) {
      for (let i in value) {
        return value.toString();
      }
    },
  },
  methods: {
    // 获取
    goTheme(item) {
      this.loading = true;
      console.log(item);
      this.list = item;
      this.classification_id = item.id;
      if (item == undefined) {
        return;
      } else {
        this.title = item.title;
        this.id = item.id;
        magazineArticleList_Api({ magazine_classification_id: item.id })
          .then((res) => {
            console.log(res);
            this.$set(this.pagination_options, "total", res.count);
            this.articleList = res.data;
            this.searchRules.id = item.id;
            this.loading = false;
            this.$global.success(this, "获取成功", null);
          })
          .catch(() => {
            this.loading = false;
            this.$global.error(this, "获取失败！", null);
          });
      }
    },
    getUploadSource(file_url) {
      this.ArticleDetail.origin_pdf = file_url;
    },
    getUploadImage(img_url) {
      this.ArticleDetail.cover_image = img_url;
    },
    // 全选按钮
    selectAll() {
      if (this.isSelectAll) {
        this.checked = [];
        this.articleList.forEach((item, i, arr) => {
          this.$set(item, "isSelect", true);
          this.checked.push(item.id);
        });
      } else {
        this.articleList.forEach((item, i, arr) => {
          item.isSelect = false;
          this.checked = [];
        });
      }
    },
    // 单选按钮
    singleCheck(index, isSelect, rowID, row) {
      if (isSelect == false) {
        this.isSelectAll = false;
        for (let i = 0; this.checked.length > i; i++) {
          if (this.checked[i] == rowID) {
            this.checked.splice(i, 1);
            return;
          }
        }
      } else {
        this.checked.push(rowID);
        if (this.checked.length == 10) {
          this.isSelectAll = true;
        }
      }
    },
    // viewDetail(item) {
    //   this.isUpdateShow = true;
    //   getArticleDetail_Api(item.id).then((res) => {
    //     this.ArticleDetail = res.data;
    //     this.ArticleDetail.article_id = res.data.id;
    //     if (this.ArticleDetail.author) {
    //       this.ArticleDetail.author = this.ArticleDetail.author.split(",");
    //     } else {
    //       this.ArticleDetail.author = [];
    //     }
    //     console.log(res);
    //   });
    // },
    viewDetail(item) {
      let route = this.$router.resolve({
        path: "/admin/magazineArticleDetail",
        query: {
          id: item.id,
          magazine_id: this.$route.query.id,
          content_type:"article",
          method: "update",
        },
        name: "magazineArticleDetail",
        params: item,
      });
      window.open(route.href, "_blank");
    },
    preview() {
      window.open("http://wupen.org/guihua/" + this.$route.query.id, "_blank");
    },
    // 修改状态
    changeState(row) {
      updateArticleDetail_Api({
        article_id: row.id,
        status: row.status,
        title: row.title,
      })
        .then(() => {
          console.log("修改状态成功！");
          this.$global.success(this, "修改状态成功！", null);
        })
        .catch((res) => {
          console.log("修改状态失败！");
        });
    },
    isDelete() {
      let delete_ids = { article_id_list: this.checked };
      console.log("delete_ids:", delete_ids);
      deleteMagazineArticleList_Api(delete_ids)
        .then((res) => {
          console.log("批量删除成功！");
          this.checked = [];
          this.deleteDialogVisible = false;
          this.$global.success(this, "删除成功！");
          this.searchRules.page = 1;
          this.goTheme(this.list);
          this.pagination_options.page = 1;
        })
        .catch((err) => {
          console.log("批量删除失败！");
        });
    },
    closeDelete() {
      this.deleteDialogVisible = false;
    },
    deleteEntryInit() {
      if (this.checked.length > 0) {
        this.deleteDialogVisible = true;
      } else {
        this.$global.error(this, "请先勾选要删除的词条！", null);
      }
    },
    addArticle() {
      // this.isUpdateShow = true;
      // for (let key in this.ArticleDetail) {
      //   this.ArticleDetail[key] = null;
      // }
      // this.ArticleDetail.status = 0;
      // this.ArticleDetail.author = [];
      let route = this.$router.resolve({
        path: "/admin/magazineArticleDetail",
        query: { method: "add",content_type:"article",magazine_id:this.$route.query.id,magazine_classification_id: this.classification_id},
      });
      window.open(route.href, "_blank");
    },
    submitBanner(item) {
      if (this.ArticleDetail.id == null) {
        // this.magazineTopicDetailList.magazine = this.themeList[0].magazine
        this.ArticleDetail.magazine_topic = this.magazine_topic_id;
        this.ArticleDetail.author = this.ArticleDetail.author.toString();
        setArticleDetail_Api(this.ArticleDetail).then((res) => {
          console.log(res);
          this.goTheme(item);
        });
        this.isUpdateShow = !this.isUpdateShow;
        return;
      } else {
        this.ArticleDetail.author = this.ArticleDetail.author.toString();
        updateArticleDetail_Api(this.ArticleDetail).then((res) => {
          this.ArticleDetail.magazine_topic = this.magazine_topic_id;
          console.log(res);
          this.goTheme(item);
        });
        this.isUpdateShow = !this.isUpdateShow;
        return;
      }
    },

    goPage(pageNo) {
      this.pagination_options.page = pageNo;
      this.searchRules.page = pageNo;
      this.goTheme(this.searchRules);
    },
  },
};
</script>



<style lang="scss" scoped>
.pc-list {
  @include table-head;
}
/deep/ .el-dialog {
  width: 70% !important;
}
/deep/.el-form
  .el-form-item
  .el-form-item__content
  div
  .logoImg
  .el-upload__tip {
  margin-top: -10px;
}
/deep/ .el-dialog__footer {
  .dialog-footer-button-one {
    @include manage-button;
    background: $test;
    color: $blueBtna;
  }
  .dialog-footer-button-second {
    @include manage-button;
  }
}
/deep/ button.el-button.el-button--primary.el-button--small {
  padding: 0;
  background: #fff;
  color: #000;
  border: none;
}
/deep/ .el-icon-document:before {
  margin-right: 10px;
}
</style>


// WEBPACK FOOTER //
// src/components/admin/guihua/components/ArticleTable.vue